export default {
  noDoors: 'There are no doors here...',
  timeOpen: 'Time open (seconds)',
  minutes: 'min.',
  open: 'Open',
  opening: 'Opening...',
  isOpen: 'Is open'
}